import React, { useState } from 'react';
import styled from 'styled-components';

import EventTypeTag from '@components/EventDetails/EventTypeTag';
import { NwFormItem } from '@components/Gui/NwForm/NwFormWrapper';
import CustomSelect from '@components/Gui/NwForm/CustomSelect';

// Larghezza minima della tendina: lascia spazio sufficiente affinche
// EventTypeTag e nome evento restino allineati su un'unica riga.
const DROPDOWN_MIN_WIDTH = 360;

// Wrapper per garantire che le regole sull'opzione raggiungano sia l'item
// selezionato sia le voci del dropdown (la tendina e' renderizzata nel
// parent del trigger tramite getPopupContainer, quindi resta dentro questo
// sottoalbero DOM).
const Wrapper = styled.div`
    .ant-select-selection-item .event-selector-option .name {
        display: block;
    }
    .event-selector-option {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        height: 100%;
        .name {
            margin-left: 10px;
            white-space: nowrap;
        }
    }
`;

const NonBookingEventSelectorForTransactions = ({
    label,
    eventSelectedUniqID,
    events,
    onChange,
    onBlur,
    disabled,
    name,
}) => {
    const [selectedEventUniqID, setSelectedEventUniqID] = useState(eventSelectedUniqID);

    const filteredEvents = events.filter((event) => event.elType !== 'Event');

    const eventOptions = [
        { value: null, label: 'No selected event' },
        ...filteredEvents.map((event) => ({
            value: event.uniqID,
            label: (
                <div className="event-selector-option">
                    <EventTypeTag event={event} />
                    <div className="name">{event.Name || event.Title}</div>
                </div>
            ),
        })),
    ];

    const onSelectChange = (value) => {
        // value puo' essere: null (clear button di CustomSelect)
        //                    | uniqID stringa (selezione normale, senza labelInValue)
        const eventUniqID = value || null;
        setSelectedEventUniqID(eventUniqID);
        if (eventUniqID) {
            const event = events.find((e) => e.uniqID === eventUniqID);
            onChange(event);
        } else {
            onChange(null);
        }
    };

    return (
        <NwFormItem
            label={label}
            control={
                <Wrapper>
                    <CustomSelect
                        name={name}
                        value={selectedEventUniqID}
                        onChange={onSelectChange}
                        onBlur={onBlur}
                        options={eventOptions}
                        allowClear
                        disabled={disabled}
                        dropdownMatchSelectWidth={false}
                        dropdownStyle={{ minWidth: DROPDOWN_MIN_WIDTH }}
                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    />
                </Wrapper>
            }
        />
    );
};

export default NonBookingEventSelectorForTransactions;
